import React from "react";

export type SpaceProps = {
  size?: number;
};

const HorizontalSpaceComponent = (props: SpaceProps): JSX.Element => (
  <div style={{ width: props.size }} />
);

export const HorizontalSpace = React.memo(HorizontalSpaceComponent);
